import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/scss';
import 'swiper/scss/navigation';
import { Navigation } from 'swiper/modules';

const GeneralInfo = ({ campaignData }) => {
  const [focusedItem, setFocusedItem] = useState(
    campaignData.video !== 'https://www.youtube.com/embed/null' ? (
      <iframe
        title='campaign video'
        className='selectedSlideVideo'
        src={campaignData.video}
        alt='nibi experience'
        frameBorder='0'
        allow='accelerometer; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      />
    ) : (
      <img
        className='selectedSlideImage'
        src={campaignData.thumbnail}
        alt='Foto del programa'
      />
    )
  );

  const images =
    Object.values(campaignData.photos.filter((photo) => photo !== '')) || [];

  return (
    <div className='generalInfo'>
      <h4>{campaignData.name}</h4>
      <a
        href={`/foundation/${campaignData.foundation.name}`}
        className='foundation-link'>
        <img
          src={campaignData.foundation.logo}
          alt='foundation logo'
        />
        {campaignData.foundation.name}
      </a>

      <div className='media'>
        <div className='focused-item'>{focusedItem}</div>

        {images && (
          <Swiper
            slidesPerView={images.length <= 2 ? 1 : images.length <= 3 ? 2 : 3}
            spaceBetween={30}
            navigation={true}
            loop={true}
            modules={[Navigation]}
            className='swiper'>
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image}
                  alt='Foto del programa'
                  onClick={() =>
                    setFocusedItem(
                      <img
                        className='selectedSlideImage'
                        src={image}
                        alt='Foto del programa'
                      />
                    )
                  }
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};
export default GeneralInfo;
